
















































import { IPayrollChangeRequest } from '@/models';
import { mapActions, mapGetters } from 'vuex';
import PayrollChangeRequestDetail from '@/components/payroll-change-request/PayrollChangeRequestDetail.vue';
import PayrollChangeRequestDetailActivityCard from '@/components/payroll-change-request/PayrollChangeRequestDetailActivityCard.vue';
import PayrollChangeRequestStateCard from '@/components/payroll-change-request/PayrollChangeRequestStateCard.vue';
import PayrollChangeRequestDetailDrawer from '@/components/payroll-change-request/PayrollChangeRequestDetailDrawer.vue';
import { ErrorManager } from '@/models/error';
import Snackbar from '@/mixins/snackbar';

export default Snackbar.extend({
  components: {
    PayrollChangeRequestDetail,
    PayrollChangeRequestDetailActivityCard,
    PayrollChangeRequestDetailDrawer,
    PayrollChangeRequestStateCard
  },

  data: () => ({
    loading: false,
    errorMessage: ''
  }),

  mounted() {
    // only fetch payrollChangeRequest if not available in store ("try-get-or-fetch")
    if (!this.payrollChangeRequest) {
      this.loading = true;
      this.fetchPayrollChangeRequest(Number(this.payrollChangeRequestId))
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  },

  computed: {
    ...mapGetters({
      getPayrollChangeRequestById:
        'payrollChangeRequest/getPayrollChangeRequestById'
    }),

    payrollChangeRequestId(): string {
      return this.$route.params.id;
    },

    payrollChangeRequest(): IPayrollChangeRequest | undefined {
      return this.getPayrollChangeRequestById(
        Number(this.payrollChangeRequestId)
      );
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  methods: {
    ...mapActions({
      fetchPayrollChangeRequest:
        'payrollChangeRequest/fetchPayrollChangeRequest'
    }),

    routeBackToList(action: string) {
      this.$router.replace({ name: 'payroll-change-request-list' }).then(() => {
        this.displaySnackbar(action);
      });
    },

    displaySnackbar(action: string) {
      this.createSnack({
        color: 'success darken-1',
        type: 'success',
        right: true,
        useBtn: false,
        msg: `Payroll Change Request ${action}`,
        btnText: 'Ok',
        timeout: 6000
      });
    }
  }
});
